import { shouldShowRemainingSlots } from '../utils/offerAvailabilityDisplay';
import type { OfferAvailabilityStatus, OfferProductSales } from '../types';

/**
 * FIN-8239: vagas restantes que a tela deve mostrar, ou `null` para esconder
 * (sem limite de vendas, sem contagem, esgotado ou acima do limiar de
 * urgência). Chamado uma vez por tela: a faixa do topo e o card do resumo
 * recebem o mesmo valor, como no `useOfferCountdown`.
 * FIN-8119 (C7): com `availability` informado, só mostra na oferta
 * `AVAILABLE`. Com `isDeadlineExpired` (prazo zerou com a página aberta,
 * mesmo estado que esconde o contador), as vagas somem junto, sem refetch
 * (R14, E12-09). O link personalizado não recebe `availability` (D10).
 */
export function useOfferRemainingSlots(
  productSales?: OfferProductSales | null,
  availability?: OfferAvailabilityStatus,
  isDeadlineExpired = false
): number | null {
  if (isDeadlineExpired) return null;
  if (availability !== undefined && availability !== 'AVAILABLE') return null;

  const remainingSlots = productSales?.remainingSlots ?? null;

  return shouldShowRemainingSlots(
    remainingSlots,
    productSales?.urgencySalesThreshold
  )
    ? remainingSlots
    : null;
}
